<template>
  <div class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="headerWrap">MULTIMESSAGE</h2>
        <div class="closeMessageModalWrapper">
          <close-icon @closeEvent="close()" :dark="true"></close-icon>
        </div>
      </div>
      <div class="modal-body">
        <transition name="slideInOut" mode="out-in">
          <keep-alive>
            <component
              :is="currentTabComponent"
              :occupiedRooms="
                currentTabComponent === 'MultiMessageRooms' ? occupiedRooms : []
              "
              :addToArchive="addTemplateToArchive"
              :selectedGuestsArray="selectedGuests"
              :sendMessage="sendingMessage"
              :archiveModalActive="archiveModalActive"
              :showSchedulerModal="schdulerModalActive"
              :selectionType="selectionType"
              @closeScheduler="closeSchedulerModal"
              @selectionChange="selectionChange"
              @sendMessageCancel="sendingMessage = false"
              @closeArchiveModal="closedArchive"
              @archived="archiveState"
              @selectedGuestObject="setSelectedGuests"
              @showRoomsSelection="currentTabComponent = 'MultiMessageRooms'"
            ></component>
          </keep-alive>
        </transition>
      </div>
      <div class="ActionButtonWrap">
        <div
          :class="{
            actionButtons: true,
            actionButtonsTemplate:
              currentTabComponent === 'MultiMessageTemplates',
          }"
        >
          <button-global
            type="positive"
            text="NEXT"
            @eventPassed="currentTabComponent = 'MultiMessageTemplates'"
            v-if="currentTabComponent === 'MultiMessageRooms'"
            :disabled="disabledActive"
          ></button-global>
          <button-global
            type="negative"
            text="BACK"
            @eventPassed="currentTabComponent = 'MultiMessageRooms'"
            v-if="currentTabComponent === 'MultiMessageTemplates'"
          ></button-global>
          <button-global
            type="neutral"
            text="SCHEDULE"
            @eventPassed="openSchedulerModal"
            v-if="currentTabComponent === 'MultiMessageTemplates'"
          ></button-global>
          <button-global
            type="positive"
            text="SEND"
            @eventPassed="sendMessage"
            :disabled="sendingMessage"
            v-if="currentTabComponent === 'MultiMessageTemplates'"
          ></button-global>
        </div>
        <div
          class="archiveButtons"
          v-if="currentTabComponent === 'MultiMessageTemplates'"
        >
          <button-global
            type="positive"
            :text="addTemplateToArchive ? 'ADDING...' : 'SAVE TEMPLATE'"
            size="medium"
            @eventPassed="addToArchive"
            :disabled="addTemplateToArchive"
          ></button-global>
          <button-global
            type="neutral"
            text="USE TEMPLATE"
            size="medium"
            @eventPassed="showArchive"
          ></button-global>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcon from "@/components/GlobalComponents/CloseIcon";
import ButtonGlobal from "@/components/GlobalComponents/ButtonGlobal";
import MultiMessageRooms from "./MultiMessageRooms";
import MultiMessageTemplates from "./MultiMessageTemplates";
import bus from "@/bus.js";

export default {
  components: {
    CloseIcon,
    ButtonGlobal,
    MultiMessageRooms,
    MultiMessageTemplates,
  },
  props: {
    occupiedRooms: Array,
  },
  data() {
    return {
      currentTabComponent: "MultiMessageRooms",
      tabs: ["MultiMessageRooms", "MultiMessageTemplates"],
      disabledActive: true,
      addTemplateToArchive: false,
      sendingMessage: false,
      archiveModalActive: false,
      schdulerModalActive: false,
      selectionType: "",
      selectedGuests: [],
    };
  },
  created() {
    bus.$on("selectedGuestChange", (value) => (this.disabledActive = value));
  },
  mounted: function () {
    document.addEventListener("keydown", this.closeWindow);
  },
  destroyed: function () {
    document.removeEventListener("keydown", this.closeWindow);
  },
  methods: {
    closeWindow(e) {
      if (e.keyCode == 27) {
        this.close();
      }
    },
    close() {
      bus.$emit("closeMultiMessage");
      this.messageSuccessModal = false;
    },
    showArchive() {
      this.archiveModalActive = true;
    },
    closedArchive() {
      this.archiveModalActive = false;
    },
    addToArchive() {
      this.addTemplateToArchive = true;
    },
    archiveState(value) {
      if (value) {
        this.addTemplateToArchive = false;
      }
    },
    sendMessage() {
      this.sendingMessage = true;
    },
    setSelectedGuests(guestArray) {
      this.selectedGuests = guestArray;
    },
    selectionChange(selection) {
      this.selectionType = selection;
    },
    openSchedulerModal() {
      this.schdulerModalActive = true;
    },
    closeSchedulerModal() {
      this.schdulerModalActive = false;
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
h1,
h2,
h3,
h4,
p {
  color: #707070;
  font-size: 16px;
}

.modal {
  position: fixed;
  z-index: 910;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
}
.closeMessageModalWrapper {
  position: absolute;
  top: 0px;
  right: 5px;
}
/* Modal Content */
.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 4px;
  background-color: #fefefe;
  margin: auto;
  margin-top: 35px;
  padding: 25px;
  width: 90%;
  height: 90%;
  border: 1px solid #707070;
  border-radius: 15px;
}
h2.headerWrap {
  margin-top: 10px;
  font-size: 32px;
  font-weight: 100;
}
.modal-body {
  height: 70%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-wrap: wrap;
  justify-content: space-between;
  /* align-self: flex-end; */
}

.ActionButtonWrap {
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 100;
}
.actionButtons {
  display: flex;
}
.actionButtonsTemplate {
  display: flex;
  flex-grow: 1;
  justify-content: center;
  margin-left: 350px;
}
.archiveButtons {
  display: flex;
}

@media screen and (max-width: 1025px) {
  .modal-body {
    flex-direction: column;
    align-items: center;
  }
  h2.headerWrap {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 28px;
    font-weight: 100;
  }
  .actionButtonsTemplate {
    margin-left: 0;
  }
}
@media screen and (max-width: 769px) {
  .selectionWrap {
    width: 100%;
    margin-bottom: 30px;
  }
  h2.headerWrap {
    margin-top: 20px;
    margin-bottom: 30px;
    font-size: 24px;
  }
  .ActionButtonWrap {
    margin-top: 0px;
    flex-direction: column-reverse;
    align-items: center;
  }
  .actionButtons {
    margin-top: 15px;
  }
}
.slideInOut-enter-active,
.slideInOut-leave-active {
  transition: all 0.2s ease;
}
.slideInOut-enter {
  transform: translateX(120px);
  opacity: 0;
}
.slideInOut-leave-to {
  transform: translateX(120px);
  opacity: 0;
}
</style>
